// Load Bootstrap JS
import bootstrap from 'bootstrap'
import slick from 'slick-carousel';
import jQuery from 'jquery';

// Load Styles
import '../scss/main.scss';

// App code

const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    const expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

const cookie = document.getElementById('cookies');
const cookieAcceptButton = document.getElementById('cookieAcceptButton');

if(cookie) {
    if(!getCookie('smarketscookie')) {
        cookie.style.display = 'block';
    }
}

if(cookieAcceptButton) {
    cookieAcceptButton.onclick = e => {
        e.preventDefault();
        cookie.style.display = 'none';
        setCookie('smarketscookie', 'true', 365);
    }
}

const carousel = document.getElementById('banner-carousel');

if(carousel) {
    jQuery('#banner-carousel').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,

      });
}



const newsCarousel = document.getElementById('news-carousel');
if(newsCarousel) {
    /*
    jQuery('#news-carousel').slick({ 
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        autoplay: true,
        arrows: false,
        mobileFirst: true
      });

      */
     
      const newsCarouselSlick = () => {
          let isSlickActive = newsCarousel.classList.contains('slick-slider');
        

          if(isSlickActive && window.innerWidth > 766) { 
            jQuery('#news-carousel').slick('unslick');

          } else if (!isSlickActive && window.innerWidth < 767) {        
                jQuery('#news-carousel').slick({ 
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,
                    autoplay: true,
                    arrows: false,
                    mobileFirst: true
                });
          }
      }

      window.onresize = newsCarouselSlick;
      window.onload = newsCarouselSlick;
}



const calculatorLayBtn = document.getElementById('calculator-lay-btn');
const calculatorLayEl = document.getElementById('calculator-lay');

const calculatorOddsBtn = document.getElementById('calculator-odds-btn');
const calculatorOddsEl = document.getElementById('calculator-ods');

const calculatorEl = document.getElementById('calculator');

if(calculatorEl && calculatorLayBtn && calculatorLayEl && calculatorOddsEl) {
    calculatorLayBtn.onclick = e => {
        e.preventDefault();

        
        if(e.target.classList.contains('active-btn')) {
            // close window
            e.target.classList.remove('active-btn');
            calculatorOddsBtn.classList.remove('active-btn');   
            calculatorEl.classList.remove('active'); 
            document.body.classList.remove('overlay-active');
        } else {
            if(calculatorEl.classList.contains('active')) {
                //switch window
                e.target.classList.add('active-btn');
                calculatorOddsBtn.classList.remove('active-btn');
                

            } else {
                // open window
                e.target.classList.add('active-btn');
                calculatorOddsBtn.classList.remove('active-btn');
                calculatorEl.classList.add('active');
                document.body.classList.add('overlay-active');
            }
            
            calculatorLayEl.classList.add('active');
            calculatorOddsEl.classList.remove('active');
        }

    }
}


if(calculatorEl && calculatorOddsBtn && calculatorLayEl && calculatorOddsEl) {
    calculatorOddsBtn.onclick = e => {
        e.preventDefault();
        
        if(e.target.classList.contains('active-btn')) {
            // close window
            e.target.classList.remove('active-btn');
            calculatorLayBtn.classList.remove('active-btn');   
            calculatorEl.classList.remove('active'); 
            document.body.classList.remove('overlay-active');
        } else {
            if(calculatorEl.classList.contains('active')) {
                //close window
                e.target.classList.add('active-btn');
                calculatorLayBtn.classList.remove('active-btn');
            } else {
                e.target.classList.add('active-btn');
                calculatorLayBtn.classList.remove('active-btn');
                calculatorEl.classList.add('active');
                document.body.classList.add('overlay-active');
            }

            
            calculatorLayEl.classList.remove('active');
            calculatorOddsEl.classList.add('active');
        }
    }

    
    window.addEventListener('click', function(e){   
        if (!document.getElementById('calculator').contains(e.target)){
        
            calculatorLayBtn.classList.remove('active-btn'); 
            calculatorOddsBtn.classList.remove('active-btn');   
            calculatorEl.classList.remove('active'); 
            document.body.classList.remove('overlay-active');  
        }
    });
}


const fractionalBtn = document.getElementById('fractional-btn');
const decimalBtn = document.getElementById('decimal-btn');
const oddsResultRow = document.getElementById('odds-results-wrap');
const resultOddsFirst = document.getElementById('result-odds-first');
const resultOddsSecond = document.getElementById('result-odds-second');

if(fractionalBtn && resultOddsSecond) {
    fractionalBtn.onclick = e => {
        e.preventDefault();
        fractionalBtn.classList.add('active');
        decimalBtn.classList.remove('active');
        oddsResultRow.classList.add('fractional-active');
        //resultOddsFirst.readOnly = false;
        //resultOddsSecond.readOnly = true;
    }
}

if(decimalBtn && resultOddsSecond) {
    decimalBtn.onclick = e => {
        e.preventDefault();
        fractionalBtn.classList.remove('active');
        decimalBtn.classList.add('active');
        oddsResultRow.classList.remove('fractional-active');
        //resultOddsFirst.readOnly = true;
        //resultOddsSecond.readOnly = false;
    }
}




const inputPlusElements = document.querySelectorAll('.plus');
const inputMinusElements = document.querySelectorAll('.minus');
const oddsFirstInput = document.getElementById('odds-first');
const oddsSecondInput = document.getElementById('odds-second');

const layFirstInput = document.getElementById('lay-first');
const laySecondInput = document.getElementById('lay-second' );
const layThirdInput = document.getElementById('lay-third');
//const resultOddsFirst = document.getElementById('result-odds-first');

if(resultOddsSecond && oddsFirstInput && oddsSecondInput && resultOddsFirst) {

    const roundToDp = (x, n) => {
        return Math.round(x * Math.pow(10, n)) / Math.pow(10, n)
    }

    resultOddsFirst.onkeyup = e => {
        e.preventDefault;
        oddsFirstInput.value = '';
        oddsSecondInput.value = '';
        let floatValue = '';

        let value = resultOddsFirst.value.trim();
        let isEmpty = value.length == 0; 
        let isFloat;
        
        let decimal = value;
        let decimalSplit = decimal.toString().split('.')
        
        try {
            if (value.includes('/')) {
                let numerator = value.split('/')[0];
                let denominator = 1;
                if (value.split('/')[1].trim().length > 0) { 
                    denominator = value.split('/')[1];
                }

                floatValue = parseFloat(numerator / denominator);

                if(floatValue.toString().split('.')[1] && floatValue.toString().split('.')[1].length > 4) {
                   floatValue = floatValue.toFixed(4);
                }
                
            } else {
                floatValue = parseFloat(value)
            }

            isFloat = !isNaN(floatValue)
        }
        catch (e) {
            floatValue = NaN;
            isFloat = false;
        }


        if (isFloat) {
            //resultOddsFirst.className = resultOddsFirst.className.replace(' error', '');
            resultOddsSecond.value = parseFloat(floatValue) + 1;

        } else if (isEmpty) {
            resultOddsSecond.value = '';
        } else {
            resultOddsSecond.value = '';
        }
    }

    resultOddsSecond.onkeyup = e => {
        e.preventDefault();
        oddsFirstInput.value = '';
        oddsSecondInput.value = '';
        let decimal = resultOddsSecond.value - 1;
        let decimalSplit = decimal.toString().split('.')

        if(resultOddsSecond.value == '') {
            resultOddsFirst.value = '';
        } else if (decimalSplit.length == 1 || decimalSplit[1] == '') {
            resultOddsFirst.value = `${ decimal }/1`;
        } else {
            let wholeNumber = parseInt(decimalSplit[0])
            let decimalNumber = parseInt(decimalSplit[1])
            let decimalLength = decimalSplit[1].length

            if (decimalLength > 10) {
                decimalSplit = roundToDp(decimal, 10).toString().split('.')
                wholeNumber = parseInt(decimalSplit[0])
                decimalNumber = parseInt(decimalSplit[1])
                decimalLength = decimalSplit[1].length;
            }

            let maxDenominator = 25
            let denominatorMult = 10**decimalLength
            let numerator = decimalNumber

            let acceptableDenominators = [
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                15,
                16,
                20,
                25,
                50,
                75,
                100,
                1000,
                10000,
                100000,
                1000000
            ]

            const checkDivisors = (num, den, acceptableDenominators) => {
                for (let i in acceptableDenominators) {
                    if ((num / den) * acceptableDenominators[i] % 1 == 0) {
                        return acceptableDenominators[i]
                    }
                }

                return den;
            }

            let denominator = checkDivisors(numerator, denominatorMult, acceptableDenominators);
            let divisor = denominatorMult / denominator;

            if (acceptableDenominators.includes(denominator)) {
                resultOddsFirst.value = `${ wholeNumber * denominator + numerator/divisor }/${ denominator }`;
            } else {
                resultOddsFirst.value = `${ decimal.toFixed(3) }/1`;
            }
        }
    }
}

const calculateOdds = () => {
    const resultOddsFirst = document.getElementById('result-odds-first');
    const resultOddsSecond = document.getElementById('result-odds-second');

    oddsFirstInput.value = parseInt(oddsFirstInput.value);
    oddsSecondInput.value = parseInt(oddsSecondInput.value);

    if(oddsFirstInput.value != '' && oddsFirstInput.value != '0' && oddsSecondInput.value != '' && oddsSecondInput.value != '0') {
        resultOddsFirst.value = `${parseInt(oddsFirstInput.value)}/${parseInt(oddsSecondInput.value)}`;
        let result = oddsFirstInput.value/oddsSecondInput.value + 1;

        if(result.toString().split('.')[1] && result.toString().split('.')[1].length > 4) {
            result = result.toFixed(4);
        } else {
            result = (Math.round(result * 100) / 100);
        }

        
        if(result != 'NaN' && result != 'Infinite' && result != '-Infinite') {
            resultOddsSecond.value = result;
        };

    } else {
        resultOddsFirst.value = '';
        resultOddsSecond.value = '';  
    }
}

const calculateLay = () => {

    const liabilityEl = document.getElementById('liabilityVal');
    const returnEl = document.getElementById('returnVal');
    const commissionEl = document.getElementById('commissionVal');
    const profitEl = document.getElementById('profitVal');

    let liabilityValue = 0;
    let returnValue = 0;
    let comissionValue = 0;
    let profitValue = 0;

    if( layFirstInput.value != '' &&
        laySecondInput.value != '' &&
        layThirdInput.value != ''
    ) {
        liabilityValue = layFirstInput.value * (laySecondInput.value - 1);
        comissionValue = layFirstInput.value * (layThirdInput.value/100);
        returnValue = layFirstInput.value;
        profitValue = returnValue - comissionValue;
    }

    liabilityEl.innerHTML = (Math.round(liabilityValue * 10) / 10).toFixed(2);
    // returnEl.innerHTML = layFirstInput.value;
    returnEl.innerHTML = (Math.round(layFirstInput.value * 10) / 10).toFixed(2);
    commissionEl.innerHTML = (Math.round(comissionValue * 10) / 10).toFixed(2);
    profitEl.innerHTML = (Math.round(profitValue * 10) / 10).toFixed(2);
}


inputPlusElements.forEach(element => {
    element.onclick = e => {
        const forElement = element.dataset.forelement;
        const currentInput = document.getElementById(forElement);
        let nextValue = 0;
        if(currentInput ) {
            if(currentInput.value != "") {
                nextValue = parseFloat(currentInput.value) + parseFloat(currentInput.step);
            }
        }

        if(nextValue > parseFloat(currentInput.max)) {
            nextValue = currentInput.max;
        }
        
        nextValue = (Math.round(nextValue * 10) / 10).toFixed(2);
        currentInput.value = nextValue;
        
        calculateOdds();
        calculateLay();
    }
});


inputMinusElements.forEach(element => {
    element.onclick = e => {
        const forElement = element.dataset.forelement;
        const currentInput = document.getElementById(forElement);
        let nextValue = 0;
        if(currentInput ) {
            if(currentInput.value != "") {
                nextValue = parseFloat(currentInput.value) - parseFloat(currentInput.step);
            }
        }

        if(nextValue < parseFloat(currentInput.min)) {
            nextValue = currentInput.min;
        }

        nextValue = Math.round(nextValue * 10) / 10;
        currentInput.value = nextValue;
        
        calculateOdds();
        calculateLay();
    }
});


if(oddsFirstInput) {
    oddsFirstInput.onkeyup = e => {
        calculateOdds();
    }
}

if(oddsSecondInput) {
    oddsSecondInput.onkeyup = e => {
        calculateOdds();
    }
}

if(layFirstInput) {
    layFirstInput.onkeyup = e => {
        calculateLay();
    }
}

if(laySecondInput) {
    laySecondInput.onkeyup = e => {
        calculateLay();
    }
}

if(layThirdInput) {
    layThirdInput.onkeyup = e => {
        calculateLay();
    }
}


const selector = document.getElementById('selector');

if(selector) {
    const selectorButton = document.getElementById('selector-heading');
    const selectorBody = document.getElementById('selector-body');

    if(selectorButton && selectorBody) {
        selectorButton.onclick = e => {
            e.preventDefault();

            selectorBody.classList.toggle('selector-body-show');
        }
    }
}

const menuSelectorButton = document.getElementById('menu-selector__heading');
const menuSelectorBody = document.getElementById('menu-selector__body');

if(menuSelectorButton && menuSelectorBody) {
    menuSelectorButton.onclick = e => {
        e.preventDefault();

        menuSelectorBody.classList.toggle('active-selector');
        menuSelectorButton.classList.toggle('active-selector');
    }
}

const mobileNavItems = document.querySelectorAll('.nav-link__mobile-button');


mobileNavItems.forEach(element => {
    element.onclick = e => {
        e.preventDefault();

        element.parentNode.parentNode.classList.toggle('active-submenu');

    }
})

const navHamburger = document.getElementById('navbar-hamburger');
if(navHamburger) {
    navHamburger.onclick = e => {
        e.preventDefault();
        navHamburger.classList.toggle('open');
    }
}


document.addEventListener("DOMContentLoaded", function() {
    const allFooterMenu = document.querySelectorAll('.footer-menu__title');
    allFooterMenu.forEach(element => {
        element.onclick = e => {
            element.parentNode.classList.toggle('active-footer');
        }
    });


    const seeMoreBtn = document.getElementById('seeMore');

    if(seeMoreBtn) {
        seeMoreBtn.onclick = e => {
            e.preventDefault();
            seeMoreBtn.parentNode.classList.toggle('active-see-more');
        }
    }
});